import React, { useState } from 'react';
import { RightOutlined } from '@ant-design/icons';

interface CollapsibleSectionProps {
	icon: React.ReactNode;
	title: string;
	/** Stays visible while collapsed so the header still summarizes the body. */
	count: number;
	/**
	 * Header action, given a way to expand the section. Adding an entry while
	 * collapsed should reveal the list rather than hide the new entry.
	 */
	action?: (expand: () => void) => React.ReactNode;
	children: React.ReactNode;
}

/**
 * Header and collapsible body shared by the issues, reviews and feedback
 * panels. Several of these stack in one column, so they start folded and the
 * header count is what tells you whether opening one is worthwhile.
 */
const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
	icon,
	title,
	count,
	action,
	children,
}) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<div className="cam-section__header">
				<button
					type="button"
					className="cam-section__title"
					aria-expanded={open}
					onClick={() => setOpen((current) => !current)}
				>
					<RightOutlined
						className={`cam-section__caret${
							open ? ' cam-section__caret--open' : ''
						}`}
					/>
					{icon}
					<span>{title}</span>
					<span className="cam-section__count">{count}</span>
				</button>
				{action?.(() => setOpen(true))}
			</div>

			{open && children}
		</>
	);
};

export default CollapsibleSection;
